export default __webpack_public_path__ + "static/columnMoving-63e3b7245b68c7ff5f9769eb285e9949.gif";